import React, { useEffect } from 'react';

const ContactRedirectPage = () => {
  useEffect(() => {
    if (typeof window !== 'undefined') {
      window.location.replace('/p/contact');
    }
  }, []);

  return (
    <main style={{ minHeight: '60vh', padding: '96px 24px', background: '#030405', color: '#fff' }}>
      <h1>Redirecting to contact...</h1>
      <p>
        If you are not redirected automatically, visit{' '}
        <a href="/p/contact" style={{ color: '#ff5c18' }}>
          /p/contact
        </a>.
      </p>
    </main>
  );
};

export default ContactRedirectPage;
